import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { useYearlyWastages } from 'hooks';
import { colors, fonts } from 'theme';
import { formatTonsFromKg } from 'utils/weight';

const useStyles = makeStyles({
  tablePaper: {
    flex: 1,
    display: 'flex',
    margin: '2em 0 0px 0',
    padding: '0 21px 0 21px',
  },
  table: {
    marginTop: '15px',
    borderCollapse: 'separate',
    borderSpacing: '0px 10px',
    background: 'white',
    borderLeft: `9px solid ${colors.primary}`,
    padding: '0 20px',
  },
  headerRow: {
    '& th': {
      fontFamily: fonts.secondary,
      fontWeight: 600,
      padding: '15px 0',
      '&:first-child': {
        paddingLeft: '44px',
      },
    },
  },
  leftAlign: {
    textAlign: 'left',
  },
  rightAlign: {
    textAlign: 'right',
  },
  rowStyle: {
    '&:last-child td': {
      border: 'none',
    },
    '& td': {
      padding: '0px 15px 8px 15px',
      fontFamily: fonts.secondary,
      '&:first-child': {
        paddingLeft: '44px',
      },
    },
  },
});

function formatPercentage(x: number | null): string {
  if (x === null) return '-';
  return `${new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 4 }).format(100 * x)} %`;
}

function getYear(x: string | Date): number {
  return new Date(x).getFullYear();
}

export const WastageList: React.FC<{}> = () => {
  const { t: pt } = useTranslation('translation', { keyPrefix: 'wastage' });
  const classes = useStyles();

  const [wastages] = useYearlyWastages();

  return (
    <Table size="small" className={classes.table}>
      <TableHead>
        <TableRow className={classes.headerRow}>
          <TableCell className={classes.leftAlign} width="12%">
            {pt('year')}
          </TableCell>
          <TableCell className={classes.rightAlign} width="22%">
            {pt('provisional.weight')}
          </TableCell>
          <TableCell className={classes.rightAlign} width="22%">
            {pt('provisional.rate')}
          </TableCell>
          <TableCell className={classes.rightAlign} width="22%">
            {pt('definitive.weight')}
          </TableCell>
          <TableCell className={classes.rightAlign} width="22%">
            {pt('definitive.rate')}
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {wastages &&
          wastages.map(wastage => (
            <TableRow className={classes.rowStyle}>
              <TableCell className={classes.leftAlign}>{getYear(wastage.validFrom)}</TableCell>
              <TableCell className={classes.rightAlign}>{formatTonsFromKg(wastage.wastageWeight)}</TableCell>
              <TableCell className={classes.rightAlign}>{formatPercentage(wastage.wastageValue)}</TableCell>
              <TableCell className={classes.rightAlign}>{formatTonsFromKg(wastage.wastageFinalWeight)}</TableCell>
              <TableCell className={classes.rightAlign}>{formatPercentage(wastage.wastageFinalValue)}</TableCell>
            </TableRow>
          ))}
      </TableBody>
    </Table>
  );
};
